import { tryCatch } from '@thalesrc/js-utils';

import HSApi from '../HSApi';
import { GetExaminationDefinitionResult } from './get-examination-definitions.result';

export async function getExaminationDefinitions(): Promise<GetExaminationDefinitionResult[]> {
  const [error, res] = await tryCatch(HSApi.get<GetExaminationDefinitionResult[]>(`/examinations/examination-definitions`));

  if (error) {
    // tslint:disable-next-line:no-console
    console.error(error);

    throw error;
  }

  return res.data;
}
